import { render, staticRenderFns } from "./LayoutViewerReadonly.vue?vue&type=template&id=ed372edc"
import script from "./LayoutViewerReadonly.vue?vue&type=script&lang=js"
export * from "./LayoutViewerReadonly.vue?vue&type=script&lang=js"
import style0 from "./LayoutViewerReadonly.vue?vue&type=style&index=0&id=ed372edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports